import { useEffect, useState } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { supabase } from './lib/supabase'
import Login from './routes/login'
import Signup from './routes/signup'
import Landing from './routes/landing'
import PostPayment from './routes/post-payment'
import AdminUsers from './routes/admin/users'
import WebhookSettings from './routes/webhooks'
import Dashboard from './routes/dashboard'
import Listings from './routes/listings'
import NewListing from './routes/listings/new'
import ListingDetail from './routes/listings/[id]'
import Leads from './routes/leads'
import LeadDetail from './routes/leads/[id]'
import Analytics from './routes/analytics'
import Settings from './routes/settings'
import Layout from './components/layout'

function App() {
  const [session, setSession] = useState<any>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session)
      setLoading(false)
    })

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session)
    })

    return () => subscription.unsubscribe()
  }, [])

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-lg">Loading...</div>
      </div>
    )
  }

  if (!session) {
    return (
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/post-payment" element={<PostPayment />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    )
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Navigate to="/listings" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/listings" element={<Listings />} />
        <Route path="/listings/new" element={<NewListing />} />
        <Route path="/listings/:id" element={<ListingDetail />} />
        <Route path="/leads" element={<Leads />} />
        <Route path="/leads/:id" element={<LeadDetail />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/webhooks" element={<WebhookSettings />} />
        <Route path="/admin/users" element={<AdminUsers />} />
      </Routes>
    </Layout>
  )
}

export default App